import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { mutateImageUrl } from '../../wordpress';

import Swiper, { Navigation, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

/**
 * Slideshow: new and improved
 *
 * @author Matt Haynes <jmatthew.haynes@joipolloi.com>
 * @package Minifigs 2.0
 */
const Slideshow = ({ images, attr }) => {
    const swiperRef = useRef(null);

    useEffect(() => {
        const thumbs = new Swiper('.swiper-product-media-thumbs', {
            spaceBetween: 15,
            slidesPerView: 5.4,
            freeMode: true,
            watchSlidesProgress: true,
            threshold: 12,
        });

        const gallery = new Swiper('.swiper-product-media-gallery .swiper', {
            modules: [Navigation, Thumbs],
            navigation: {
                nextEl: '.swiper-product-media-gallery .swiper-button-next',
                prevEl: '.swiper-product-media-gallery .swiper-button-prev',
            },
            slidesPerView: 1,
            thumbs: {
                swiper: thumbs,
            },
        });
        swiperRef.current = gallery;
    }, []);

    useEffect(() => {
        if (attr?.image?.url && !!images.length) {
            const attrUrl = attr.image.url;
            const index = images.findIndex((image) => image.node.url === attrUrl);
            swiperRef.current.slideTo(index);
        }
    }, [images, attr]);

    return (
        <div className="product-media">
            {images?.length > 0 && (
                <div className="slideshow-images">
                    <div className="swiper-product-media-gallery">
                        <ul className="swiper">
                            <div className="swiper-wrapper">
                                {images.map((image, idx) => (
                                    <li className="swiper-slide" key={idx}>
                                        <img src={mutateImageUrl(image.node.url, 400, 400)} alt="" />
                                    </li>
                                ))}
                            </div>
                        </ul>
                    </div>

                    <ul className="swiper-product-media-thumbs">
                        <div className="swiper-wrapper">
                            {images.map((image, idx) => (
                                <li className="swiper-slide" key={idx}>
                                    <img src={mutateImageUrl(image.node.url, 400, 400)} alt="" />
                                </li>
                            ))}
                        </div>
                    </ul>
                </div>
            )}
        </div>
    );
};

Slideshow.propTypes = {
    images: PropTypes.array.isRequired,
};

export default Slideshow;
